import {dateTime} from "services/date";
import {TicketType} from "types/TicketType";

/**
 * Transform the given ticket type by deserializing object properties
 *
 * @internal
 * @param ticketType
 */
export default function deserializeTicketType(ticketType: any): TicketType {
    ticketType.created_at = dateTime(ticketType.created_at)
    ticketType.updated_at = dateTime(ticketType.updated_at)

    return ticketType;
}